<template src="./LoadingComponent.html"></template>
<script>
import ModalDeliveryProductListComponent
  from "@/components/modals/modal-delivery-product-list/ModalDeliveryProductListComponent.vue";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";

export default {
  name: 'LoadingComponent',
  components: {
    InputTextNormal, ButtonSearchComponent, InputCheckboxOne, PaginateComponent,
    ModalDeliveryProductListComponent
  },
  setup() {
    return {

    }
  },
}
</script>
<style lang="scss">
  .loading {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1090;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
    transition: opacity 0.15s linear;
    background-color: rgba(0,0,0,0.4);
  }
</style>
